import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a16aa48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-columns" }
const _hoisted_2 = { class: "section-left" }
const _hoisted_3 = { class: "section-right" }

import CSection from "@/components/section/CSection.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CSectionTwoColumn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "left")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "right")
        ])
      ])
    ]),
    _: 3
  }))
}
}

})